export default __webpack_public_path__ + "static/media/10d.3697a128.jpg";